import { render, staticRenderFns } from "./xgAreaDataboard.vue?vue&type=template&id=25627aa3&scoped=true"
import script from "./xgAreaDataboard.vue?vue&type=script&lang=js"
export * from "./xgAreaDataboard.vue?vue&type=script&lang=js"
import style0 from "./xgAreaDataboard.vue?vue&type=style&index=0&id=25627aa3&prod&lang=scss&scoped=true"
import style1 from "./xgAreaDataboard.vue?vue&type=style&index=1&id=25627aa3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25627aa3",
  null
  
)

export default component.exports